import React from 'react'

export default function EstatePlanning() {
    return (
        <div>
            <p>
                The overall purpose of the estate planning process is to develop a plan that will enhance 
                and maintain the financial independence for you and your family as well as alleviate the financial 
                impact of your death on those you leave behind. 
            </p>
            <p>
                Estate planning is a continuous process. Sometimes changes in your life - such as a sudden increase 
                in wealth, a new marriage or remarriage, the birth of a child, a serious illness, or a death in the 
                family - can trigger the need for an estate plan evaluation. A well-constructed estate plan may not 
                only reduce the tax bill, but also help your loved ones understand, resolve and prepare for many of 
                the issues that arise when settling an estate.
            </p>
            <p>
                We work closely with your estate planning attorney to help understand the process of planning an 
                estate and strategies to protect, conserve and distribute your estate in the most efficient manner 
                possible.
            </p>
        </div>
    )
}